export const AUDIO_PATH = 'resource/audio/';
export const AUDIO_PACK_PATH = 'resource/audio/packs/';

/**
 * AUDIO_PACK is used to keep track of your sprite sheets url path.
 */
export const AUDIO_PACKS = {
    cardSystem: AUDIO_PACK_PATH + 'card-system/card-system-audio.json',
    fieldSystem: AUDIO_PACK_PATH + 'field-system/field-system-audio.json',
    levelSystem: AUDIO_PACK_PATH + 'level-system/level-system-audio.json',
    uiSystem: AUDIO_PACK_PATH + 'ui-system/ui-system-audio.json',
    luckyTurnipsSystem: AUDIO_PACK_PATH + 'lucky-turnips-system/lucky-turnips-system-audio.json',
    petSystem: AUDIO_PACK_PATH + 'pet-system/pet-system-audio.json',
    wheelSystem: AUDIO_PACK_PATH + 'wheel-system/wheel-system-audio.json',
    farmSystem: AUDIO_PACK_PATH + 'farm-system/farm-system-audio.json',
};

/**
 * list of "AMBIENT" audio level world
 */
export const AUDIO_LEVEL_AMBIENT_WORLD = ['world/world_1_Ingame.mp3'];
